import { ExpenseCategory, IncomeCategory } from "@boo/shared";
import type { CategoryBreakdown } from "@boo/shared";

// CategoryBreakdown extended with UI display fields
export interface CategoryStat extends CategoryBreakdown {
  label: string;
  color: string; // hex for charts
}

// Category color mapping (UI-only)
export const CATEGORY_COLORS: Record<ExpenseCategory, string> = {
  [ExpenseCategory.FOOD]: "#EF9F27",
  [ExpenseCategory.TRANSPORT]: "#FAC775",
  [ExpenseCategory.SHOPPING]: "#8B5CF6",
  [ExpenseCategory.BILLS]: "#4fd6a5",
  [ExpenseCategory.ENTERTAINMENT]: "#BA7517",
  [ExpenseCategory.HEALTH]: "#f07a7a",
  [ExpenseCategory.HOUSING]: "#8B5CF6",
  [ExpenseCategory.FINANCIAL]: "#06B6D4",
  [ExpenseCategory.INVESTMENT]: "#10B981",
  [ExpenseCategory.OTHER]: "#B4B2A9",
};

export const CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  [ExpenseCategory.FOOD]: "Food & Drink",
  [ExpenseCategory.TRANSPORT]: "Transport",
  [ExpenseCategory.SHOPPING]: "Shopping",
  [ExpenseCategory.BILLS]: "Bills & Utilities",
  [ExpenseCategory.ENTERTAINMENT]: "Entertainment",
  [ExpenseCategory.HEALTH]: "Health",
  [ExpenseCategory.HOUSING]: "Housing",
  [ExpenseCategory.FINANCIAL]: "Financial",
  [ExpenseCategory.INVESTMENT]: "Investment",
  [ExpenseCategory.OTHER]: "Other",
};

// Display order for category pickers
export const EXPENSE_CATEGORIES: ExpenseCategory[] = [
  ExpenseCategory.FOOD,
  ExpenseCategory.TRANSPORT,
  ExpenseCategory.SHOPPING,
  ExpenseCategory.BILLS,
  ExpenseCategory.ENTERTAINMENT,
  ExpenseCategory.HEALTH,
  ExpenseCategory.HOUSING,
  ExpenseCategory.FINANCIAL,
  ExpenseCategory.INVESTMENT,
  ExpenseCategory.OTHER,
];

export const INCOME_CATEGORY_COLORS: Record<IncomeCategory, string> = {
  [IncomeCategory.SALARY]: "#10B981",
  [IncomeCategory.BONUS]: "#34D399",
  [IncomeCategory.FREELANCE]: "#06B6D4",
  [IncomeCategory.BUSINESS]: "#0EA5E9",
  [IncomeCategory.INVESTMENT]: "#8B5CF6",
  [IncomeCategory.RENTAL]: "#F59E0B",
  [IncomeCategory.OTHER]: "#B4B2A9",
};

export const INCOME_CATEGORY_LABELS: Record<IncomeCategory, string> = {
  [IncomeCategory.SALARY]: "Salary",
  [IncomeCategory.BONUS]: "Bonus",
  [IncomeCategory.FREELANCE]: "Freelance",
  [IncomeCategory.BUSINESS]: "Business",
  [IncomeCategory.INVESTMENT]: "Investment",
  [IncomeCategory.RENTAL]: "Rental",
  [IncomeCategory.OTHER]: "Other",
};
